module.exports = " <div class=ProgressBar _v-496f0994=\"\"> <div class=ProgressBar-bar _v-496f0994=\"\"> <div class=ProgressBar-fill :style=\"{ width: fillWidth }\" _v-496f0994=\"\"> <div class=ProgressBar-fillPadding _v-496f0994=\"\"> {{ current }} / {{ max }} <slot _v-496f0994=\"\"></slot> </div> </div> <div class=ProgressBar-text _v-496f0994=\"\"> {{ current }} / {{ max }} <slot _v-496f0994=\"\"></slot> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-496f0994!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ProgressBar.vue
// module id = 128
// module chunks = 2